export const SEARCH_V2_URL = '/search'
